import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import Header from './components/Header';
import AdminLayout from './components/AdminLayout';
import Dashboard from './components/Dashboard';
import PropertyList from './components/PropertyList';
import AppointmentScheduler from './components/AppointmentScheduler';
import MapView from './components/MapView';
import DayPlanner from './components/DayPlanner';
import ClientList from './components/ClientList';
import ClientDetail from './components/ClientDetail';
import TodayView from './components/TodayView';
import LoginPage from './components/LoginPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import VerifyEmailPage from './components/VerifyEmailPage';
import ResendVerificationPage from './components/ResendVerificationPage';
import RegisterPage from './components/RegisterPage';
import AdminDashboard from './components/AdminDashboard';
import AdminOrganizations from './components/AdminOrganizations';
import AdminUsers from './components/AdminUsers';
import OrgSettings from './components/OrgSettings';

function RequireAuth({ children }) {
  return localStorage.getItem('token') ? children : <Navigate to="/login" replace />;
}

function RequireSystemAdmin({ user, children }) {
  if (!localStorage.getItem('token')) return <Navigate to="/login" replace />;
  if (user && !user.is_system_admin) return <Navigate to="/" replace />;
  return children;
}

function App() {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });

  const handleLogin = (u) => setUser(u);
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={
            localStorage.getItem('token') ? <Navigate to="/" replace /> : <LoginPage onLogin={handleLogin} />
          } />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/register" element={<RegisterPage onLogin={handleLogin} />} />
          <Route path="/verify-email" element={<VerifyEmailPage onLogin={handleLogin} />} />
          <Route path="/resend-verification" element={<ResendVerificationPage />} />

          {/* Admin portal — standalone layout */}
          <Route path="/admin/*" element={
            <RequireSystemAdmin user={user}>
              <AdminLayout user={user} onLogout={handleLogout}>
                <Routes>
                  <Route index element={<AdminDashboard />} />
                  <Route path="organizations" element={<AdminOrganizations />} />
                  <Route path="users" element={<AdminUsers />} />
                </Routes>
              </AdminLayout>
            </RequireSystemAdmin>
          } />

          {/* Main app */}
          <Route path="*" element={
            <RequireAuth>
              <Header user={user} onLogin={handleLogin} onLogout={handleLogout} />
              <main key={user?.org_id ?? 'no-org'} style={{ padding: '24px', maxWidth: 1400, margin: '0 auto' }}>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/properties" element={<PropertyList />} />
                  <Route path="/schedule" element={<AppointmentScheduler />} />
                  <Route path="/map" element={<MapView />} />
                  <Route path="/plan" element={<DayPlanner />} />
                  <Route path="/clients" element={<ClientList />} />
                  <Route path="/clients/:id" element={<ClientDetail />} />
                  <Route path="/today" element={<TodayView />} />
                  <Route path="/org" element={<OrgSettings user={user} />} />
                </Routes>
              </main>
            </RequireAuth>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
